import React, { Component, Fragment } from 'react';
import { MealTypes as _MealTypes, filterAllergensByCountry, URL_VERSION3 } from "../../../server/constants";

const styles={
    allergenItem:{
        width: '100%',
        padding: '5px',
        border: 'solid 1px #dedede',
        margin:'4px',
        cursor:'pinter',
    },
    allergenItemActive:{
        width: '100%',
        padding: '5px',
        border: '1px solid #ea7066',
        margin:'4px',
        cursor:'pinter',
    },
    img:{
        width:'30px'
    },
    allergenText:{
        //display:'inline-block',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        //width:'180px'
        fontSize:'13px',            
    }
}
class AllergensCtrl extends Component {
    constructor(props){
        super(props);
        this.state={
            showMore:true
        }
    }
    allergenTitleOverflowHandle=(title='')=>{
        if(title.length>=15){
            return title.substring(0,12)+'...';
        }else{
            return title;
        }
    }
    
    render() {
        const {defaultNoOfItems, allergensInfo, onAllergensChange}=this.props;
        const allergens = filterAllergensByCountry(sessionStorage.getItem('countryCode'));
        const {showMore}=this.state;
        return (
            <Fragment>
                <div className='row' style={{maxHeight:'200px', overflowY:'auto', overflowX:'hidden'}}>
                    <div className='col-md-12'>
                        <div className='row'>
                            {
                                Object.keys(allergens).map((itm,i)=>{
                                    if((showMore) && i>defaultNoOfItems){
                                        return null;
                                    }
                                    return <div className='col-sm-6 col-md-3' style={{paddingLeft:'2px', paddingRight:'2px'}}>
                                        <div style={(allergensInfo||[]).includes(itm)? {...styles.allergenItemActive}:{...styles.allergenItem}} onClick={()=>{
                                            onAllergensChange(itm);
                                        }}>
                                            <img src={allergens[itm].image} className="img-fluid" style={styles.img} /> <span style={styles.allergenText}>{this.allergenTitleOverflowHandle(allergens[itm].display)}</span>
                                        </div>
                                    </div>
                                })
                            }

                            {(Object.keys(allergens).length>12)? 
                                    showMore && <div className='col-sm-6 col-md-3' style={{paddingTop:'13px'}}>
                                        <a href='javascript:void(0)' onClick={()=>this.setState({showMore:false})}>show more</a>
                                    </div>

                                : null}
                        </div>

                    </div>
                </div>                
            </Fragment>
        );
    }
}

export default AllergensCtrl;


// WEBPACK FOOTER //
// ./src/components/Misc/allergensCtrl/index.js